import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import CheckCircleIcon from 'design-system/src/assets/icons/checkCircle.svg?react';
import { useState, useEffect } from 'react';
import WarningIcon from 'design-system/src/assets/icons/warning.svg?react';
import { standardTransitionStyles } from 'design-system/src/sharedStyles';
import { Tooltip } from 'design-system/src/components/Tooltip/Tooltip';
import { breakpoints } from 'design-system/src/tokens/breakpoints';

export const SaveStatusContainer = styled.div<{ $show: boolean }>`
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  align-items: center;
  gap: 8px;
  ${standardTransitionStyles}
`;

const SaveStatusText = styled(Typography)`
  @media (max-width: ${breakpoints.mobileMax}px) {
    display: none;
  }
`;

const SAVE_STATUS_DURATION_MS = 2000;
export function SaveStatus({ state }: { state: 'saving' | 'saved' | 'failed' }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (state === 'saving') {
      setShow(true);
    } else if (state === 'failed') {
      setShow(true);
    } else if (state === 'saved') {
      setShow(true);
      const hideIndicatorTimeout = setTimeout(() => {
        setShow(false);
      }, SAVE_STATUS_DURATION_MS);
      return () => clearTimeout(hideIndicatorTimeout);
    }
  }, [state]);
  return (
    <SaveStatusContainer $show={show}>
      {state === 'saving' && (
        <>
          <SaveStatusText styledAs="bodyExtraSmallSpaceGrotesk"> Saving </SaveStatusText>
          <Tooltip content="Saving" childNotInteractive>
            <LoadingSpinner height="16px" />
          </Tooltip>
        </>
      )}
      {state === 'saved' && (
        <>
          <SaveStatusText styledAs="bodyExtraSmallSpaceGrotesk"> Changes saved </SaveStatusText>
          <Tooltip content="Changes saved" childNotInteractive>
            <CheckCircleIcon title="saved" />
          </Tooltip>
        </>
      )}
      {state === 'failed' && (
        <>
          <SaveStatusText styledAs="bodyExtraSmallSpaceGrotesk"> Failed to save </SaveStatusText>
          <Tooltip content="Failed to save" childNotInteractive>
            <WarningIcon title="failed" />
          </Tooltip>
        </>
      )}
    </SaveStatusContainer>
  );
}
